<template>
	<div>
		<p class="title-p gray-background">推送内容:</p>
		<van-cell-group>
			<van-cell>
				<p>
					<span>疫情通告：<span v-text="contentText"></span><span>。通告人：<span v-text="userName"></span><span>。时间：<span v-text="nowDate"></span></span></span></span>
				</p>
			</van-cell>
		</van-cell-group>

		<p class="title-p gray-background">相关人:</p>
		<van-cell-group>
			<van-cell>
				<div class="display-flex-box">
					<p v-text="stuName" :class="{'color-gray': stuName == '请选择'}"></p>
					<p class="add-stu" @click="navTo()">添加</p>
				</div>
			</van-cell>
		</van-cell-group>

		<van-field v-model="contentText" rows="1" autosize label="内容" type="textarea" placeholder="请输入备注信息" />

		<p class="title-p gray-background">说明:</p>
		<div class="desc-box">
			<p>本信息将会以短信的形式推送给以下人员:</p>
			<p v-text="groupUsersStr"></p>
			<p>以及学生班主任和家长</p>
		</div>



		<van-button type="info" block @click="sendSms">启动推送</van-button>
		<bottom-tab></bottom-tab>
	</div>
</template>

<script>
	import Vue from 'vue';
	import api from '../../http/api.js'

	import {
		Cell,
		CellGroup,
		Toast,
		Button,
		Field
	} from 'vant';

	Vue.use(Field);
	Vue.use(Cell);
	Vue.use(CellGroup);
	Vue.use(Toast);
	Vue.use(Button);

	export default {
		data() {
			return {
				groupUsersStr: '',
				selectStudentUid: 7449,
				templateId: 544590,
				selectStudentName: "学生",
				userId: window.localStorage.getItem('uid'), // 操作人ID
				userName: '', //操作人名字
				groupId: 22,
				deptId: window.localStorage.getItem('scDeptId'),
				stuName: '请选择', //相关人
				contentText: '', // 内容
				nowDate: this.formatDate(new Date(), 'yyyy/MM/dd HH:mm:ss')
			}
		},
		methods: {
			pageInit() {
				api.getUserInfo(this.userId).then(res => {
					if (res.data.code == 200) {
						this.userName = res.data.data.name
					} else {
						Toast('获取失败：' + res.data.msg)
					}
				})
				this.loadGroupUsers(this.groupId)
			},
			navTo() {
				this.$router.push({
					path: '/searchStuMsg',
					query: {
						isVirus: 1
					}
				})
			},

			sendSms: function() {
			    if(this.stuName == '请选择'){
			        Toast('请添加相关人')
                    return
                }
				let data = JSON.stringify({
					groupIds: [this.groupId],
					params: [this.contentText, this.selectStudentName, this.userName],
					stuRole: {
						deptIds: [parseInt(window.localStorage.getItem('selectStuDepts'))],
						roleIds: [6,7],
						stuUserId: this.selectStudentUid
					}
				});
				api.toTargetMessage(data).then(res => {
					if (res.data.code == 200) {
						Toast("推送成功")
					} else {
						Toast("推送失败" + res.data.msg)
					}
				})
			},

			loadGroupUsers: function(gid) {
				let page = this
				api.getUserGroup(gid).then(res => {
					// console.log(res);
					if (res.data.code == 200) {
						let users = res.data.data.content
						if (users && users.length > 0) {
							page.groupUsersStr = users.map(user => {
								return user.name
							}).join(', ')
						}
					} else {
						Toast('提交失败：' + res.data.msg)
					}
				})
			},
			formatDate(date, fmt) {
				date = date == undefined ? new Date() : date;
				date = typeof date == "number" ? new Date(date) : date;
				fmt = fmt || "yyyy-MM-dd HH:mm:ss";
				let obj = {
					y: date.getFullYear(), // 年份，注意必须用getFullYear
					M: date.getMonth() + 1, // 月份，注意是从0-11
					d: date.getDate(), // 日期
					q: Math.floor((date.getMonth() + 3) / 3), // 季度
					w: date.getDay(), // 星期，注意是0-6
					H: date.getHours(), // 24小时制
					h: date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, // 12小时制
					m: date.getMinutes(), // 分钟
					s: date.getSeconds(), // 秒
					S: date.getMilliseconds() // 毫秒
				};
				let week = ["天", "一", "二", "三", "四", "五", "六"];
				for (let i in obj) {
					fmt = fmt.replace(new RegExp(i + "+", "g"), function(m) {
						let val = obj[i] + "";
						if (i == "w") return (m.length > 2 ? "星期" : "周") + week[val];
						for (let j = 0, len = val.length; j < m.length - len; j++)
							val = "0" + val;
						return m.length == 1 ? val : val.substring(val.length - m.length);
					});
				}
				return fmt;
			}
		},
		mounted() {
			this.pageInit();
		},
		activated() {
			if (!this.$route.meta.isBack) {
				this.stuName = '请选择' //相关人
				this.contentText = '' // 内容
			} else {
				this.selectStudentName = window.localStorage.getItem('selectStuName')
				this.stuName = window.localStorage.getItem('selectStuName')
				this.selectStudentUid = window.localStorage.getItem('selectStuId')
				window.localStorage.removeItem('selectStuName')
			}
		},
		beforeRouteEnter(to, from, next) {
			if (from.name != 'searchStuMsg') {
				to.meta.isBack = false;
			} else {
				to.meta.isBack = true;
			}
			next();
		}
	}
</script>

<style scoped>
	span {
		line-height: 1rem;
	}

	.title-p {
		margin: 0;
		line-height: 50px;
		padding-left: 10px;
	}

	.add-stu {
		color: #409EFF;
	}

	.desc-box {
		padding: 0px 16px;
	}
</style>
